import { QueryParamsHandling } from '@angular/router';

interface ISnRoute {
  link?: string | any[];
  replaceUrl?: boolean;
  skipLocationChange?: boolean;
  state?: { [key: string]: any };
  fragment?: string;
  preserveFragment?: boolean;
  queryParams?: { [key: string]: any };
  queryParamsHandling?: QueryParamsHandling;
  target?: string;
}

export type SnRouteConfig = string | ISnRoute;
